module.exports = __webpack_public_path__ + "static/media/kamil_rodoper.40b3245c.png";